import {defineComponent} from "vue";
import {GoogleMapMarkerInterface} from "../Views/PageView/Interfaces/Components/GoogleMapMarkerInterface";

export default defineComponent({
	methods: {
		markerWindowDetails(element: GoogleMapMarkerInterface, isAdmin: boolean = false) {
			let title = element?.title ? `<h3>${element.title ?? ''}</h3>` : '';
			let address = element?.address ? `<p><a href='https://maps.google.com/?q=${element.lat},${element.lng}' target="_blank">${element.address}</a></p>` : '';
			let email = element?.email ? `<p><a href='mailto:${element.email}'>${element.email}</a></p>` : '';
			let telephone = element?.telephone ? `<p><a href='tel:${element.telephone}'>${element.telephone}</a></p>` : '';
			let extraText = element?.extraText ? `<p>${element.extraText ?? ''}</p>` : '';
			let deleteBtn = '';
			if (isAdmin) {
				deleteBtn = `<hr class="my-2"><button type="button" class="button-unit button-unit--error button-unit--sm" id="marker_${element.id}">Törlés</button>`;
			}
			return `<div>${title}${address}${email}${telephone}${extraText}${deleteBtn}</div>`;
		}
	},
	computed: {
		countryStrike(): string {
			const style = getComputedStyle(document.documentElement);
			return style.getPropertyValue('--color-profile').trim();
		},
		roadColor(): string {
			const style = getComputedStyle(document.documentElement);
			return style.getPropertyValue('--color-footer-section-content-text').trim();
		},
		geometryColor(): string {
			const style = getComputedStyle(document.documentElement);
			return style.getPropertyValue('--color-page-bg').trim();
		},
		googleMapStyles(): any[] {
			return [
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": this.geometryColor
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.business",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": this.roadColor
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "geometry.stroke",
					"stylers": [
						{"color": this.countryStrike},
						{"weight": 2}
					]
				}
			];
		}
	}
});
